import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { Transaccion } from 'src/app/dashboard/interfaces/transaccion.interface';
import { TransaccionService } from 'src/app/dashboard/services/transaccion.service';
import { EditTransactionModalComponent } from '../../assigned-transactions/edit-transaction-modal/edit-transaction-modal.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { EditTransactionDTO } from 'src/app/dashboard/interfaces/edit-transaction.dto';
import Swal from 'sweetalert2';
import { AddBeneficiarioCripto } from 'src/app/dashboard/interfaces/add-beneficiario-cripto.interface';
import { RecipientCriptoService } from 'src/app/dashboard/services/recipient-cripto.service';
import { etiquetaRed, medioCriptoDe, validarDireccion } from 'src/app/shared/utils/red-cripto';

@Component({
  selector: 'app-edit-cripto-transaction',
  templateUrl: './edit-cripto-transaction.component.html',
  styleUrls: ['./edit-cripto-transaction.component.sass']
})
export class EditCriptoTransactionComponent {
  datosForm: FormGroup | undefined;
  tiposID = ['CI', 'PASAPORTE', 'RUT'];
  transaccion: any;
  constructor(
    private auth: CognitoService,
    private readonly transactionService: TransaccionService,
    private fb: FormBuilder,
    private recipientcriptoservice: RecipientCriptoService,
    private spinner: SpinnerService, public dialogRef: MatDialogRef<EditCriptoTransactionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any){
      this.transaccion = data;
      this.initForm();
  }

  /**
   * La red es la del beneficiario de la fila y no se ofrece cambiarla: el
   * guardado de wallet-back conserva la red del beneficiario en una edición
   * (una dirección de una red no sirve en otra). Antes se mostraba siempre
   * "RED Tron (TRC 20)", también para una transacción de Polygon o Solana.
   */
  get red(): string {
    return etiquetaRed(this.transaccion?.medioCriptoId, this.transaccion?.redCripto);
  }

  /**
   * La dirección se valida con el formato de la red de la transacción, igual
   * que en el alta y que en wallet-back. Antes tenía un `maxLength(20)` (desde
   * 2023) que dejaba inválida cualquier wallet real —una TRC20 ya mide 34— y
   * el botón Guardar quedaba gris sin remedio.
   */
  private validarDireccionDeLaRed = (control: AbstractControl): ValidationErrors | null => {
    const valor = typeof control.value === 'string' ? control.value.trim() : '';
    if (!valor) return null;
    const motivo = validarDireccion(this.transaccion?.medioCriptoId, valor);
    return motivo ? { direccionInvalida: motivo } : null;
  };

  initForm(){
    this.datosForm = this.fb.group({
      nombre: new FormControl( this.transaccion.nombre, [Validators.required, Validators.maxLength(40)]),
      apellido: new FormControl(  this.transaccion.apellidos  , [Validators.required, Validators.maxLength(40)]),
      medioRecepcion: new FormControl(  this.transaccion.medioRecepcion, [Validators.required, this.validarDireccionDeLaRed]),
    })
  }



  async guardarBeneficiario(){

    if (this.datosForm?.invalid){
      return
    }
    const formValue = this.datosForm?.value;
    // La red de la fila y no un 1 fijo (ya no son todas TRC20). Sin
    // `recepcion`, que no es columna.
    const cuentaBeneficiary: AddBeneficiarioCripto = {
      ...formValue,
      medioCriptoId: medioCriptoDe(this.transaccion?.medioCriptoId),
      id: this.data.idBeneficiario
    }
    let swalConfig = {}
      swalConfig = {
        icon: 'success',
        title: 'Transacción actualizada',
        text: 'Su transacción fue actualizada con éxito',
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1e5a3f',
      };

    const ref = this.spinner.start();
    try{
      const resultado = await this.recipientcriptoservice.saveRecipientAccount(
        cuentaBeneficiary
      );
      Swal.fire(swalConfig);
      this.dialogRef.close(true);
    }catch (error){
    }
    this.spinner.stop(ref);
  }


  cancel(){
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();
  }
}
